<div class="table-responsive">
  <table class="table table-hover">
    <tr>
      @for (headerItem of data.tableHeader; track headerItem; let i = $index) {
        <th>
          <span>{{'tables.' + headerItem.columnId | translate}}</span>
          <span [ngClass]="{'activeSorting': headerItem.iconActiveStatus}">
            @if (headerItem.sortingOrderStatus === sortOrder.Ascending) {
              <i class="{{headerItem.ascIconClass}}"
              (click)="sortBy(headerItem.columnId,i, headerItem.sortingOrderStatus)"></i>
            }
            @if (headerItem.sortingOrderStatus === sortOrder.Descending) {
              <i class="{{headerItem.descIconClass}}"
              (click)="sortBy(headerItem.columnId,i, headerItem.sortingOrderStatus)"></i>
            }
            @if (headerItem.sortingOrderStatus === undefined) {
              <i class="{{headerItem.ascIconClass}}"
              (click)="sortBy(headerItem.columnId,i, headerItem.sortingOrderStatus)"></i>
            }
          </span>
        </th>
      }
      @if (actionIcons) {
        <th class="smallWidth">
          {{'tables.actions' | translate}}
        </th>
      }
    </tr>
    @for (bodyItem of tableList | async; track bodyItem; let index = $index) {
      <tr class="tbodyRows">
        @for (column of bodyItem; track column) {
          <td
            [ngClass]="{'ellipsisCell': column.ellipsisCellStatus, 'StatusColumn': column.statusColumn}">
            @if (column.clickableStatus) {
              <a [routerLink]="column.link + data.tableBody[index].id">
                {{column.value}}
              </a>
            }
            @if (column.ellipsisCellStatus) {
              <p class="ellipsisSpan" [tooltip]="column?.tooltip">
                @if (column.valueIsArray) {
                  <span>
                    @for (item of column.value; track item; let i = $index) {
                      <span>
                        {{item.name}}
                        @if (i !== column.value.length -1) {
                          <span>,</span>
                        }
                      </span>
                    }
                  </span>
                }
                @if (!column.valueIsArray) {
                  <span>
                    <span>
                      {{column.value?.name}}
                    </span>
                  </span>
                }
              </p>
            }
            @if (column.dateColumn) {
              <span>
                @if (column.showDay) {
                  <span>{{column.value | date: 'dd. MMM, yyyy'}}</span>
                }
                @if (!column.showDay) {
                  <span>{{column.value | date: 'MMM, yyyy'}}</span>
                }
              </span>
            }
            @if (!column.clickableStatus && !column.ellipsisCellStatus && !column.dateColumn && column.checkboxStatus === null) {
              <span
                >
                @if (column.addDownloadIcon && column.value) {
                  <span>
                    {{column.value.fileName}}
                  </span>
                }
                @if (!column.addDownloadIcon) {
                  <span>
                    {{column.value}}
                  </span>
                }
                @if (column.addDownloadIcon && column.value) {
                  <span class="downloadIcon"
                    (click)="downloadFile(data.tableBody[index])">
                    <i class="bi bi-download"></i>
                  </span>
                }
                @if (column.failedStatusIcon) {
                  <span class="failedIcon" [tooltip]="column.failedStatusMessage" placement="left"
                    >
                    <i class="bi bi-exclamation-triangle"></i>
                  </span>
                }
              </span>
            }
            <!--        <tradestrat-switch-button *ngIf="column.checkboxStatus === true"-->
            <!--                                  [disabled]="true"-->
            <!--                                  [value]="column.value"-->
            <!--                                  [btnType]="'squareCheckbox'"-->
          <!--                                  [labelText]=""></tradestrat-switch-button>-->
        </td>
      }
      @if (actionIcons) {
        <td class="smallWidth actionsColumns">
          @if (actionIcons.hasDropDownForIcons) {
            <div class="d-flex align-items-end">
              @if (actionIcons.uploadFile) {
                <span class="uploadContainer" tooltip="Upload file" placement="auto"
                  (click)="uploadEmitter(data.tableBody[index])">
                  <i class="bi bi-upload"></i>
                </span>
              }
              @if (actionIcons.editIcon && !actionIcons.uploadFile) {
                <span tooltip="Edit" placement="auto"
                  (click)="editEmitter(data.tableBody[index])">
                  <i class="bi bi-pencil"></i>
                </span>
              }
              @if (actionIcons.duplicateIcon) {
                <span tooltip="Duplicate" placement="auto"
                  (click)="duplicateEmitter(data.tableBody[index])">
                  <i class="far fa-copy"></i>
                </span>
              }
              <div class="btn-group dropleft" dropdown [dropup]="data.tableBody.length -1 === index">
                <span id="button-disabled-item" dropdownToggle aria-controls="dropdown-disabled-item">
                  <i class="fas fa-ellipsis-v"></i>
                </span>
                <ul id="dropdown-disabled-item" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                  role="menu" aria-labelledby="button-disabled-item">
                  @if (actionIcons.editIcon && actionIcons.uploadFile) {
                    <li class="disabled" role="menuitem"
                      (click)="editEmitter(data.tableBody[index])">
                      <span><i class="bi bi-pencil"></i></span>Edit
                    </li>
                  }
                  @if (actionIcons.shareIcon) {
                    <li class="disabled" role="menuitem">
                      <span><i class="fas fa-share"></i></span>Share
                    </li>
                  }
                  @if (actionIcons.archiveIcon) {
                    <li role="menuitem">
                      <span><i class="fas fa-archive"></i></span>Archive
                    </li>
                  }
                  @if (actionIcons.deleteIcon) {
                    <li role="menuitem" (click)="deleteEmitter(data.tableBody[index])">
                      <span>
                        <i class="fas fa-trash-alt"></i>
                      </span>
                      Delete
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
          @if (!actionIcons.hasDropDownForIcons) {
            <div class="d-flex align-items-end">
              @if (actionIcons.editIcon) {
                <span tooltip="Edit" placement="auto"
                  (click)="editEmitter(data.tableBody[index])">
                  <i class="bi bi-pencil"></i>
                </span>
              }
              @if (actionIcons.duplicateIcon) {
                <span tooltip="Duplicate" placement="auto"
                  (click)="duplicateEmitter(data.tableBody[index])">
                  <i class="far fa-copy"></i>
                </span>
              }
              @if (actionIcons.shareIcon) {
                <span tooltip="Share" placement="auto">
                  <i class="fas fa-share"></i>
                </span>
              }
              @if (actionIcons.archiveIcon) {
                <span tooltip="Archive" placement="auto">
                  <i class="fas fa-archive"></i>
                </span>
              }
              @if (actionIcons.deleteIcon) {
                <span tooltip="Delete" placement="auto"
                  (click)="deleteEmitter(data.tableBody[index])">
                  <i class="bi bi-trash"></i>
                </span>
              }
            </div>
          }
        </td>
      }
    </tr>
  }
  @if (adaptedData?.length === 0 && !isLoading) {
    <tr class="emptyRow">
      <td colspan="9" class="pt-5">
        <!--        <tradestrat-empty-list [title]="emptyData.title" [paragraph]="emptyData.paragraph"></tradestrat-empty-list>-->
      </td>
    </tr>
  }
</table>
</div>
